import React from "react";
import { Text, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import ImageInBackground from "./ImageInBackground";
import styles from "../style/layout_components/ImageBanner.module.scss";

const ImageBanner = (props) => {
  return (
    <>
      <div className={styles.heroBar}>
        <ImageInBackground className={styles.heroBar} imageUrl={props.fields.image.value.src}>
          <div className={styles.heroBarCard}>
            <div className={styles.heroBarTriangle}></div>
            <div className={styles.heroBarWrapper}>
              <div className={styles.heroBarContent}>
                <h3>
                  <Text field={props.fields.bannerHeading} />
                </h3>
                <p>
                  <Text field={props.fields.bannerText} />
                </p>
              </div>
            </div>
          </div>
        </ImageInBackground>
      </div>
    </>
  );
};

export default withSitecoreContext()(ImageBanner);
